<template lang="pug">
.product-Image
  CardMinimal(title="Image", :key="imagesKey")
    .p-a-3
      .upload-area(v-if="images.length === 0", :class="`${highlighted ? 'highlighted' : ''}`")
        .upload-text(v-if="state === ''")
          i.mdi.mdi-folder
          | {{ $t('products.attach_new_image') }}...
        .upload-text(v-if="state === 'uploading'")
          i.mdi.mdi-loading.mdi-spin.loading
        input(type="file", multiple, ref="upload-area-input" @change="uploadImages($event.target.files)", @dragenter="highlight(true)", @dragleave="highlight(false)")
      .image-gallery
        .images
          img(v-for="(image, index) in images", :key="index", :src="`https://${fqdn.split('.')[0]}.streamify.io/images/300x300/${image.value}`", :class="`${galleryIndex === index ? 'active' : ''}`")
        .dots(v-if="images.length > 1")
          .dot(v-for="(image, index) in images", :key="`dot-${index}`", @click="galleryIndex = index", :class="`${galleryIndex === index ? 'active' : ''}`")
      .image-list(v-if="images.length > 1")
        .image(v-for="(image, index) in images", :key="index")
          img(:src="`https://${fqdn.split('.')[0]}.streamify.io/images/64x64/${image.value}`")
          span {{ index === 0 ? 'Huvudbild' : 'Extrabild' }}
          .icon-button-group.ml-a
            .icon-button.large-icon(:class="`${index === images.length - 1 ? 'gray' : 'blue'}`", @click="index === images.length - 1 ? null : move(false, index)"): .icon-button-inner: i.mdi.mdi-menu-down
            .icon-button.large-icon(:class="`${index === 0 ? 'gray' : 'blue'}`", @click="index === 0 ? null : move(true, index)"): .icon-button-inner: i.mdi.mdi-menu-up
          .icon-button.red.m-l-1(@click="images[index].deleted = true"): .icon-button-inner: i.mdi.mdi-trash-can-outline
      .upload-input
        input(type="file", multiple, ref="upload-input", @change="uploadImages($event.target.files)")
    .p-a-4.d-f.ai-c.jc-c(slot="footerButton", v-if="images.length > 0", @click="state === 'uploading' ? null : $refs['upload-input'].click()")
      template(v-if="state === 'uploading'")
        i.mdi.mdi-loading.mdi-spin
      template(v-else)
        i.mdi.mdi-plus-circle
        span {{ $t('products.add_image') }}
</template>

<script>

export default {
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    /**
     * Upload image
     * @param {Array} images
     */
    async uploadImages(images) {
      if (images.length === 0) {
        return;
      }

      this.state = 'uploading';

      // eslint-disable-next-line
      for (const image of images) {
        if (['image/jpeg', 'image/png'].indexOf(image.type) >= 0) {
          const imageData = new FormData();
          imageData.append('file', image);
          // eslint-disable-next-line
          const result = await this.$store.dispatch('Upload/uploadImages', imageData);
          if (result) {
            this.images.push({ value: result.filename });
          }
        }
      }

      if (this.$refs['upload-area-input']) {
        this.$refs['upload-area-input'].value = '';
      }
      if (this.$refs['upload-input']) {
        this.$refs['upload-input'].value = '';
      }

      this.state = '';
    },
    /**
     * Set highlighted
     * @param {Boolean} bool
     */
    highlight(bool) {
      this.highlighted = bool;
    },
    /**
     * Move image in array
     * @param {Boolean} up
     * @param {Number} index
     */
    move(up, index) {
      const [image] = this.images.splice(index, 1);
      this.images.splice(up ? index-1 : index+1, 0, image);
    },
    validate() {
      return true;
    },
    async update() {
      const { images } = this;
      await this.$store.dispatch('Products/updateImages', {
        id: this.editData.id,
        images: images.map(image => image.value),
      });

      return true;
    },
    reset() {
      if (this.editData && this.edit) {
        this.images = this.editData.images.map(i => ({ value: i, deleted: false }));
        this.imagesKey += 1;
      }
    },
  },
  watch: {
    images(images) {
      this.$emit('data', images.map(i => i.value));
    },
  },
  data() {
    return {
      galleryIndex: 0,
      state: '',
      images: [],
      highlighted: false,
      imagesKey: 0,
    };
  },
  mounted() {
    if (this.edit && this.editData) {
      this.images = this.editData.images.map(i => ({ value: i, deleted: false }));
    }
  }
};
</script>

<style lang="scss">
</style>


<style lang="scss" scoped>
.upload-area {
  border: 1px dashed #979797;
  position: relative;
  transition: border-color .3s;

  &.highlighted {
    border-color: #0062FF;
  }

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }

  .upload-text {
    align-items: center;
    color: #0062FF;
    display: flex;
    justify-content: center;
    height: 100%;
    padding: 15px;
    position: absolute;
    word-break: break-word;
    width: 100%;
    pointer-events: none;

    i {
      margin-right: 10px;
      font-size: 1.5rem;

      &.loading {
        font-size: 2.5rem;
      }
    }
  }

  input[type="file"] {
    height: 100%;
    position: absolute;
    width: 100%;
    opacity: 0;

    &:hover {
      cursor: pointer;
    }
  }
}

.image-gallery {
  .images {
    border-radius: 4px;
    overflow: hidden;

    img {
      display: none;

      &.active {
        display: block;
      }
    }
  }

  .dots {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 12px 0;

    .dot {
      border: 2px solid #ADAEAF;
      border-radius: 100%;
      width: 10px;
      height: 10px;
      margin-right: 12px;

      &:last-child {
        margin-right: 0;
      }
      
      &:hover {
        cursor: pointer;
      }
      
      &.active {
        background-color: black;
        border: 1px solid black;
        height: 12px;
        width: 12px;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
          margin-left: -2px;
        }
      }
    }
  }
}

.image-list {
  .image {
    align-items: center;
    display: flex;
    margin-bottom: 4px;

    img {
      margin-right: 12px;
      line-height: 0;
    }
  }
}

.upload-input {
  visibility: hidden;
  overflow: hidden;
  height: 0px;
  width: 0px;
}
</style>